const state = {
   open: false,
   severityValue: [],
   sortBy: 'Severity',
   service: null,
   region: null,
   stationCode: '',
   alertListSearchInput: '',
   isAllAlerts: false,
   stationAlertListSearchInput: '',
   allStationsListInput: '',
   stationsInRangeListInput: '',
   stationRadius: 10,
   highOrLow: null,
   selectedRegion: null,
   userID: '',
   userName: '',
   userPosition: []
}

const getters = {
   getModalState: $state => $state.open,
   getSeverityValue: $state => $state.severityValue,
   getSortBy: $state => $state.sortBy,
   getService: $state => $state.service,
   getRegion: $state => $state.region,
   getStationCode: $state => $state.stationCode,
   getAlertListSearchInput: $state => $state.alertListSearchInput,
   getIsAllAlerts: $state => $state.isAllAlerts,
   getStationAlertListSearchInput: $state => $state.stationAlertListSearchInput,
   getAllStationsListInput: $state => $state.allStationsListInput,
   getStationsInRangeListInput: $state => $state.stationsInRangeListInput,
   getStationRadius: $state => $state.stationRadius,
   getHighOrLow: $state => $state.highOrLow,
   getSelectedRegion: $state => $state.selectedRegion,
   getStateUserID: $state => $state.userID,
   getStateUserName: $state => $state.userName,
   getStateUserPosition: $state => $state.userPosition
}

const mutations = {
   setModal($state, payload) {
      $state.open = payload
   },
   setSeverityValue($state, payload) {
      $state.severityValue = payload
   },
   setSortBy($state, payload) {
      $state.sortBy = payload
   },
   setService($state, payload) {
      $state.service = payload
   },
   setRegion($state, payload) {
      $state.region = payload
   },
   setStationCode($state, payload) {
      $state.stationCode = payload
   },
   setAlertListSearchInput($state, payload) {
      $state.alertListSearchInput = payload
   },
   setIsAllAlerts($state, payload) {
      $state.isAllAlerts = payload
   },
   setStationAlertListSearchInput($state, payload) {
      $state.stationAlertListSearchInput = payload
   },
   setAllStationsListInput($state, payload) {
      $state.allStationsListInput = payload
   },
   setStationsInRangeSearchInput($state, payload) {
      $state.stationsInRangeListInput = payload
   },
   setStationRadius($state, payload) {
      $state.stationRadius = payload
   },
   setHighOrLow($state, payload) {
      $state.highOrLow = payload
   },
   setSelectedRegion($state, payload) {
      $state.selectedRegion = payload
   },
   setStateUserID($state, payload) {
      $state.userID = payload
   },
   setStateUserName($state, payload) {
      $state.userName = payload
   },
   setStateUserPosition($state, payload) {
      $state.userPosition = payload
   }
}

export default {
   state,
   getters,
   mutations
}
